import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { RepairPaymentDto } from '../../repair-payment/dto/repair-payment.dto';
import { JobRepairSheetInterface } from '../interfaces/job-repair-sheet.interface';
import { RepairTypeEnum } from '../../repair/enums/repair-type.enum';
import { RepairPaymentInterface } from '../../repair-payment/interfaces/repair-payment.interface';

@Exclude()
export class JobRepairSheetDto
  extends CommonEntityDto
  implements JobRepairSheetInterface
{
  @ApiProperty({
    title: 'Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'Builder Id',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'Building Id',
  })
  @Expose()
  buildingId!: string | null;

  @ApiProperty({
    title: 'Building Number',
  })
  @Expose()
  buildingNumber!: string | null;

  @ApiProperty({
    title: 'Job Lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job Block',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Address1',
  })
  @Expose()
  address1!: string;

  @ApiProperty({
    title: 'Address2',
  })
  @Expose()
  address2!: string | undefined;

  @ApiProperty({
    title: 'Zip',
  })
  @Expose()
  zip!: string;

  @ApiProperty({
    title: 'City',
  })
  @Expose()
  city!: string;

  @ApiProperty({
    title: 'State',
  })
  @Expose()
  state!: string;

  @ApiProperty({
    title: 'Repair Date',
  })
  @Expose()
  repairDate!: Date;

  @ApiProperty({
    title: 'Repair Id',
  })
  @Expose()
  repairId!: string;

  @ApiProperty({
    title: 'Description',
  })
  @Expose()
  description!: string;

  @ApiProperty({
    title: 'Description',
  })
  @Expose()
  repairTypeDescription!: string;

  @ApiProperty({
    title: 'Repair Type',
  })
  @Expose()
  repairType!: RepairTypeEnum;

  @ApiProperty({
    title: 'Job Id',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserId!: string;

  @ApiProperty({
    title: 'Region Id',
  })
  @Expose()
  regionId!: string;

  @Expose()
  @ApiProperty({
    title: 'poTotal',
  })
  poTotal!: number;

  @Expose()
  @ApiProperty({
    title: 'poTotalOverride',
  })
  poTotalOverride!: number;

  @ApiProperty({
    type: () => [RepairPaymentDto],
    title: 'Job Payment',
    description: 'The Job Payment associated with this job',
  })
  @Expose()
  repairPayments?: RepairPaymentInterface[];
}
